<template>
<div>
  <secondHeader />
  <div class="main-roulette">
    <sidebar />
    <div class="roulette-container">
      <div class="roulette-canvas">
      <canvas ref="rouletteCanvas" width="500" height="500"></canvas>
      </div>
      <div class="roulette-controls">
        <!-- 結果＆操作エリア -->
        <div class="control-section result-section">
          <div class="selected-item-container">
              <template v-if="selectedItem">
                <p class="result-label">選ばれたのは...</p>
                <p class="result-value" :title="selectedItem.name">{{ truncateText(selectedItem.name, 20) }}</p>
              </template>
              <p v-else class="selected-item placeholder">結果がここに表示されます</p>
          </div>
          <div class="roulette-buttons">
              <button @click="startRoulette" :disabled="isSpinning || items.length < 2" class="start-btn">スタート</button>
              <button @click="stopRoulette" :disabled="!isSpinning" class="stop-btn">ストップ</button>
          </div>
        </div>

        <!-- 入力管理エリア -->
        <div class="control-section input-section">
          <form @submit.prevent="addItems" class="add-item-form">
              <textarea 
                v-model="newItemsText" 
                placeholder="項目を入力（改行で複数追加可能）"
                rows="5"
              ></textarea>
              <button type="submit">追加</button>
          </form>
          <div class="item-list">
              <ul>
                  <li v-for="(item, index) in items" :key="index">
                      <input 
                        v-model="item.name" 
                        class="item-name-input" 
                        @input="drawRoulette"
                        maxlength="20"
                      >
                      <div class="item-weight">
                        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#B7B7B7" style="vertical-align: -4px;"><path d="M264-216h432l-49-360H313l-49 360Zm216-432q20.4 0 34.2-13.8Q528-675.6 528-696q0-20.4-13.8-34.2Q500.4-744 480-744q-20.4 0-34.2 13.8Q432-716.4 432-696q0 20.4 13.8 34.2Q459.6-648 480-648Zm110 0h57q27.16 0 47.08 17.5Q714-613 718-586l49 360q5 32.44-16.39 57.22Q729.23-144 695.95-144H264.28q-33.28 0-54.78-24.78T193-226l49-360q4-27 23.92-44.5T313-648h57q-5-11-7.5-23t-2.5-25q0-50 35-85t85-35q50 0 85 35t35 85q0 13-2.5 25t-7.5 23ZM264-216h432-432Z"/></svg>
                        <input 
                          v-model.number="item.weight" 
                          type="number" 
                          min="1" 
                          max="100" 
                          class="weight-input"
                          @input="drawRoulette"
                        >
                      </div>
                      <button @click="removeItem(index)" class="roulette-remove-button">✕</button>
                  </li>
              </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue"
import sidebar from "../components/sidebar.vue"

export default {
  components:{
    sidebar,
    secondHeader
  },
  data() {
    return {
      items: [],
      newItemsText: '',
      isSpinning: false,
      angle: 0,
      selectedItem: null,
      ctx: null,
      centerX: 250,
      centerY: 250,
      radius: 200,
      spinSpeed: 0.2,
      deceleration: 0.99, // 減速率
      minSpinSpeed: 0.001, // 最小回転速度
    }
  },
  methods: {
    addItems() {
      const lines = this.newItemsText.split('\n').filter(line => line.trim())
      lines.forEach(line => {
        const name = line.trim().slice(0, 20) // 最大20文字
        if (name) {
          this.items.push({ name, weight: 1 })
        }
      })
      this.newItemsText = ''
      this.drawRoulette()
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.drawRoulette()
    },
    startRoulette() {
      if (this.items.length < 2) return
      this.isSpinning = true
      this.selectedItem = null
      this.spinSpeed = 0.2 + Math.random() * 0.1 // 初期回転速度をランダムに設定
      this.spin()
    },
    stopRoulette() {
      this.isSpinning = false
    },
    spin() {
      if (this.isSpinning) {
        this.angle += this.spinSpeed
        this.drawRoulette()
        requestAnimationFrame(this.spin)
      } else {
        this.slowDown()
      }
    },
    slowDown() {
      this.spinSpeed *= this.deceleration
      this.angle += this.spinSpeed
      this.drawRoulette()

      if (this.spinSpeed > this.minSpinSpeed) {
        requestAnimationFrame(this.slowDown)
      } else {
        this.selectItem()
      }
    },
    selectItem() {
      const normalizedAngle = (this.angle % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
      const totalWeight = this.items.reduce((sum, item) => sum + item.weight, 0);
      let accumulatedWeight = 0;
      
      for (let i = 0; i < this.items.length; i++) {
        const startAngle = (2 * Math.PI * accumulatedWeight) / totalWeight;
        accumulatedWeight += this.items[i].weight;
        const endAngle = (2 * Math.PI * accumulatedWeight) / totalWeight;
        
        if (normalizedAngle >= startAngle && normalizedAngle < endAngle) {
          this.selectedItem = this.items[i];
          break;
        }
      }
    },
    drawRoulette() {
      this.ctx.clearRect(0, 0, 500, 500);

      if (this.items.length === 0) {
        // 要素がない場合、空の円を描画
        this.ctx.beginPath();
        this.ctx.arc(this.centerX, this.centerY, this.radius, 0, 2 * Math.PI);
        this.ctx.fillStyle = '#E0E0E0'; // 薄いグレー
        this.ctx.fill();
        this.ctx.strokeStyle = '#BDBDBD'; // 濃いめのグレー
        this.ctx.lineWidth = 2;
        this.ctx.stroke();

        // 「項目を追加してください」というテキストを表示
        this.ctx.fillStyle = '#757575'; // 濃いグレー
        this.ctx.font = 'bold 20px Arial';
        this.ctx.textAlign = 'center';
        this.ctx.textBaseline = 'middle';
        this.ctx.fillText('項目を追加してください', this.centerX, this.centerY);
      } else {
        const totalWeight = this.items.reduce((sum, item) => sum + item.weight, 0);
        let startAngle = 0;

        // ルーレットを回転
        this.ctx.save();
        this.ctx.translate(this.centerX, this.centerY);
        this.ctx.rotate(-this.angle);
        this.ctx.translate(-this.centerX, -this.centerY);

        this.items.forEach((item, index) => {
          const sliceAngle = (2 * Math.PI * item.weight) / totalWeight;
          const endAngle = startAngle + sliceAngle;

          this.ctx.beginPath();
          this.ctx.moveTo(this.centerX, this.centerY);
          this.ctx.arc(this.centerX, this.centerY, this.radius, startAngle, endAngle);
          this.ctx.closePath();

          this.ctx.fillStyle = this.getColor(index);
          this.ctx.fill();

          this.ctx.save();
          this.ctx.translate(this.centerX, this.centerY);
          this.ctx.rotate(startAngle + sliceAngle / 2);
          this.ctx.textAlign = 'right';
          this.ctx.fillStyle = '#333333';
          this.ctx.font = 'bold 14px Arial';
          this.ctx.fillText(this.truncateText(item.name, 10), this.radius - 10, 0);
          this.ctx.restore();

          startAngle = endAngle;
        });

        this.ctx.restore();
      }

      // 矢印を描画（回転しない）
      this.ctx.beginPath();
      this.ctx.moveTo(this.centerX + this.radius + 2, this.centerY);
      this.ctx.lineTo(this.centerX + this.radius + 22, this.centerY - 12);
      this.ctx.lineTo(this.centerX + this.radius + 22, this.centerY + 12);
      this.ctx.closePath();
      this.ctx.fillStyle = '#333333';
      this.ctx.fill();

      // 白いボーダーで視認性向上
      this.ctx.shadowColor = 'transparent';
      this.ctx.strokeStyle = '#ffffff';
      this.ctx.lineWidth = 2;
      this.ctx.stroke();
    },
    getColor(index) {
      const colors = [
        '#FFB3BA', // ライトピンク
        '#BAFFC9', // ライトグリーン
        '#BAE1FF', // ライトブルー
        '#FFFFBA', // ライトイエロー
        '#FFDFBA', // ライトオレンジ
        '#E0BBE4', // ライトパープル
        '#D4F0F0', // ライトシアン
        '#FFC6FF', // ライトマゼンタ
        '#DCEDC1', // ライトライム
        '#FFD1DC', // ライトコーラル
      ];
      return colors[index % colors.length];
    },
    truncateText(text, maxLength) {
      if (text.length <= maxLength) {
        return text;
      }
      return text.slice(0, maxLength) + '...';
    }
  },
  mounted() {
    this.ctx = this.$refs.rouletteCanvas.getContext('2d')
    this.drawRoulette()
  }
}
</script>

<style scoped>
.main-roulette {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}

.roulette-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  padding: 60px 20px;
  font-family: Arial, sans-serif;
  background-color: transparent;
  width: 100%;
}

.roulette-controls {
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.control-section {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #ddd;
}

.result-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.input-section {
  display: flex;
  flex-direction: column;
}

.add-item-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.add-item-form textarea {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

.add-item-form button {
  padding: 10px;
  background-color: #0f172a;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.15s ease;
}

.add-item-form button:hover {
  background-color: #1e293b;
}

.roulette-buttons button {
  padding: 10px 20px;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.15s ease;
}

.roulette-buttons .start-btn {
  background-color: #16a34a;
}

.roulette-buttons .start-btn:hover {
  background-color: #15803d;
}

.roulette-buttons .stop-btn {
  background-color: #dc2626;
}

.roulette-buttons .stop-btn:hover {
  background-color: #b91c1c;
}

.item-list {
  margin-bottom: 20px;
}

.item-list h3 {
  margin-bottom: 10px;
  color: #333;
}

.item-list ul {
  list-style-type: none;
  padding: 0;
}

.item-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.item-name-input {
  font-weight: bold;
  max-width: 120px;
  padding: 5px 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  background-color: #fafafa;
  transition: border-color 0.2s, background-color 0.2s;
}

.item-name-input:focus {
  outline: none;
  border-color: #2196F3;
  background-color: #fff;
}

.item-weight {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #666;
  font-size: 0.9em;
}

.weight-input {
  width: 50px;
  padding: 5px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  transition: border-color 0.2s, background-color 0.2s;
}

.weight-input:focus {
  outline: none;
  border-color: #2196F3;
  background-color: #fff;
}

/* Chrome, Safari, Edge のスピンボタンを非表示 */
.weight-input::-webkit-outer-spin-button,
.weight-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox のスピンボタンを非表示 */
.weight-input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.roulette-remove-button {
  background-color: #ff9999;
  color: white;
  padding: 5px 10px;
  font-size: 0.8em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.roulette-remove-button:hover {
  background-color: #ff6666;
}

.roulette-buttons {
  display: flex;
  gap: 10px;
}

.roulette-buttons button {
  flex: 1;
}

.roulette-buttons button:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
}

.selected-item-container {
  min-height: 50px;
  padding: 12px 16px;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.result-label {
  margin: 0;
  font-size: 12px;
  color: #64748b;
}

.result-value {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #0f172a;
}

.selected-item.placeholder {
  color: #94a3b8;
  font-weight: normal;
  font-size: 14px;
  margin: 0;
}
</style>